<template>

<AppHeaderDropdown right no-caret>
    <template slot="header">
    <!--     <img src="img/avatars/6.jpg" class="img-avatar" alt="" /> -->
    <i class="fa fa-user-circle" aria-hidden="true"></i>
    </template>
    <b-dropdown-header tag="div" class="text-center">
        <strong>{{getuser}}</strong>
    </b-dropdown-header>

    <template slot="dropdown">
        <b-dropdown-item @click="editProfile"><i class="fa fa-user" />Edit Profile</b-dropdown-item>
        <!-- <b-dropdown-item><i class="fa fa-user" /> <router-link :to="{name: 'Edit User', params: { id: getID }}">Profile</router-link></b-dropdown-item> -->
        <b-dropdown-item @click="submitLogout"><i class="fa fa-lock" /> Logout</b-dropdown-item>
    </template>
</AppHeaderDropdown>

</template>

<script>

import {
    HeaderDropdown as AppHeaderDropdown
}
from '@coreui/vue'
export default {
    name: 'DefaultHeaderDropdownAccnt',
    components: {
        AppHeaderDropdown
    },
    data() {
        return {}
    },
    methods: {
        submitLogout() {
                this.$store.dispatch('logout')
                    .then(() => {
                        this.$router.push('/login')
                        console.log("success")
                    })
                    .catch((error) => {
                        this.$router.push('/login')
                        console.log("goodbye")
                    })
            },
            editProfile() {
                this.$router.push({
                    name: 'Edit User',
                    params: {
                        id: this.getID
                    }
                });

            }

    },
    computed: {
        getuser: function() {
            return this.$store.getters.getUserName
        },
        getID: function() {
            return this.$store.getters.getUserID
        }
    },
}

</script>
